<template>
  <div class="project">
    <div class="p-image"></div>

    <div class="right-container">
      <div class="bg">
        <!-- <transition name="fadeOne"> -->
        <!-- <div v-show="show" class="container-2"> -->
        <p class="One">Toilet shop</p>

        <p class="description">
          The main part of this project was to have a fully working CRUD
          application using Vue.js
        </p>
        <!-- </div>
        </transition> -->
        <transition name="fadeTwo">
          <div class="container-2">
            <a href="https://bagel-79264.web.app/" class="Two"
              >click here to visit</a
            >
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.container-2 {
  clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
  display: grid;
  place-items: center;
}
.project {
  width: auto;
  height: auto;
  background: #000;
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 15px;
}
button {
  color: #435466;
  font-size: 15px;
  font-weight: 600;
  background-color: #fff;
  margin: auto;
  width: 100px;
  height: 50px;
  border: #3b3561;
}
.right-container {
  display: grid;
  grid-template-rows: 1fr 0.1fr;
  text-align: left;
}
.p-image {
  background: url("../assets/toilet shop.png");
  height: 35vh;
  width: 62vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
p {
  text-align: start;
  font-size: 50px;
  font-family: "Stalinist One", cursive;
  overflow: hidden;
  color: #4dba87;
  margin: 1px;
}
.description {
  font-size: 1.5em;
  font-family: "Roboto", sans-serif;
}
.Two {
  font-size: 18px;
  text-decoration: none;
  color: tomato;
  margin: 20px 0 0 0;
}

.fadeOne-enter-active,
.fadeOne-leave-active {
  transition: all 0.5s ease-out;
}
.fadeOne-enter,
.fadeOne-leave-to {
  clip-path: polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%);
  transform: translate(0%, 100%);
}

.fadeTwo-enter-active,
.fadeTwo-leave-active {
  transition: all 0.5s ease-out;
}
.fadeTwo-enter,
.fadeTwo-leave-to {
  clip-path: polygon(0% 100%, 100% 100%, 0% 100%, 0% 100%);
  transform: translate(0%, -100%);
}
@media screen and (max-width: 600px) {
  .project {
    width: 100%;
    grid-template-columns: 1fr;
    place-items: center;
  }
  .p-image {
    width: 44.4vh;
    height: 25vh;
  }
}
</style>
